module.exports = __webpack_public_path__ + "static/img/IMG_0533.fa129f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-ajto/IMG_0533.jpg
// module id = 561
// module chunks = 0